
import { Vue } from "vue-property-decorator";
import Component from "vue-class-component";
import { DateTime } from "luxon";
import { globalStore } from '@/store/globalStore';
import { http } from "@/config/HttpClient";
import { Reporte } from "@/addons/Reporte";
import HeadReport from "@/components/HeadReport.vue";
import ListaGeneralTable from "./ListaGeneralTable.vue";
import ResumenClientesTable from './ResumenClientesTable.vue';
import ResumenFuentesTable from "./ResumenFuentesTable.vue";
import ResumenPeriodoTable from "./ResumenPeriodoTable.vue"
import {SancionService} from "@/services/SancionService";
import {sancionStore} from "@/store/sancionStore";


@Component({
  name: "InventarioGeneral",
  components: { HeadReport }
})
export default class ReporteCisternaIndex extends Vue {

  private globalStore = globalStore();

  public dialog = false;
  public DateTime = DateTime;

   fechaInicial = DateTime.now().toFormat("yyyy-MM-dd");
   fechaFinal = DateTime.now().toFormat("yyyy-MM-dd");

  datos = [];
  lista_general: any[] = []
  otros_ingresos = [];
  fecha_inicial = DateTime.now().toFormat("yyyy-MM-dd");
  fecha_final = DateTime.now().toFormat("yyyy-MM-dd");
  public txtSearch = "";
  conceptos: any[] = []
  concepto = null
  loading = false
  search = null
  swPrint = 'listaGeneral'
  swTitle = 'LISTADO GENERAL DE REGISTRO POR COMPRAS DE AGUA EN CISTERNAS'
  get nombre_concepto(): string {
    if (this.concepto !== null) {
      return this.conceptos.find(el => el.codigo == this.concepto).nombre;
    }
    return '';
  }
  mounted() {
    //this.getVentasAgua();
    //this.getConceptos();
    this.getInventario()
  }

  getInventario() {
    this.lista_general = [];
    this.loading = true
    this.swPrint = 'listaGeneral'
    this.swTitle = 'INVENTARIO GENERAL'
    let datos = { search: this.search }
    http.get('getInventarioGeneral', { params: datos })
        .subscribe((response) => {
          this.lista_general = response.data.inventario;
          this.loading = false;
        }, (error) => {
          console.log(error)
          this.loading = false;
        })
  }
  getMinimos() {
    this.lista_general = [];
    this.loading = true
    this.swPrint = 'listaGeneral'
    this.swTitle = 'INVENTARIO DIARIO'
    let datos = { fecha_inicial: this.fecha_inicial, fecha_final: this.fecha_final }
    http.get('minimos', { params: datos })
        .subscribe((response) => {
          this.lista_general = response.data.minimos;
          this.loading = false;
        }, (error) => {
          console.log(error)
          this.loading = false;
        })
  }
  imprimir() {
    const p = new Reporte(this.swPrint);
    p.orientacion = 'horizontal';
    p.imprimir();
  }

}
